<h6>Project duration / quarter</h6>

<div class="collapse" style="position: absolute; top:25px; left:15px; z-index: 2; height:320px; padding:10px;">
    <div class="card p-2">
        <p class="mb-0">Template 1</p>
    </div>
</div>
<div class="card bg-secondary p-2 pl-1 pr-1">
    <div id="chartdiv1" style="width: 100%; height: 300px; padding:0px;"></div>
</div>

